<script setup lang="ts">
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import { computed } from 'vue'

const { token = '', sizePreset = CertificateSealSizePreset.Display } = defineProps<{
  token: string
  sizePreset: CertificateSealSizePreset
}>()

const sealText = computed(() => {
  return token ? `#${token}` : ''
})
</script>

<script lang="ts">
export enum CertificateSealSizePreset {
  Display = 'display',
  Print = 'print',
}

export default {}
</script>

<template>
  <div :class="[sizePreset === CertificateSealSizePreset.Display ? 'w-[93px] h-[93px]' : 'w-[142px] h-[142px]']">
    <!--
      Pass an explicit pixel width so Vivaldi resizes the 902² seal. Without it,
      process-image fetches a full-size webp (~100–150 kB) and trips the
      dashboard image byte-budget e2e gate (100 kB/image).
    -->
    <ImageThumbnail
      resize-strategy="fit"
      :aspect-ratio="1"
      :width="sizePreset === CertificateSealSizePreset.Display ? 93 : 142"
      :height="sizePreset === CertificateSealSizePreset.Display ? 93 : 142"
      :original-image-width="902"
      :original-image-height="902"
      :process-image="true"
      src="https://padlet.net/dashboard/belt/v2_certificate_seal_base.png"
      alt="Certificate seal"
    />
    <p
      :class="[
        'select-none pointer-events-none',
        'seal-text absolute rotate-[5deg]',
        // position
        sizePreset === CertificateSealSizePreset.Display ? 'my-0 top-[15px] start-[33px]' : 'top-[21px] start-[51px]',
        // font size
        sizePreset === CertificateSealSizePreset.Display ? 'text-[6px]' : 'text-[9px]',
      ]"
    >
      {{ sealText }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.seal-text {
  font-family: 'Syne Mono', monospace;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.4px;
  text-align: center;
  color: #966100;
  box-shadow: inset 0.3px 0.3px 0.6px 0 rgba(246, 214, 31, 0.3);
  filter: drop-shadow(-1.2px 1.2px 2.4px rgba(242, 210, 31, 0.2))
    drop-shadow(1.2px -1.2px 2.4px rgba(255, 255, 255, 0.2));
}
</style>
